export const translation = {
  zenit: {
    en: {
      siteTitle: 'Your bonuses | Zenit',
      bottomTitle: 'to your deposit',
      footnoteText: '*read more in Terms and Conditions of the Promotion',
      getBtn: 'Get your bonus',
      menuRules: 'rules'
    },
    ru: {
      siteTitle: 'Твои бонусы | ZENIT',
      bottomTitle: 'на депозит',
      footnoteText: '*подробнее в Правилах',
      getBtn: 'Забрать бонус',
      menuRules: 'Правила'

    },
    br: {
      siteTitle: 'Welcome Bonus| ZENIT',
      bottomTitle: 'AO SEU DEPÓSITO',
      footnoteText: '* LEIA MAIS EM TERMOS E CONDIÇÕES DA PROMOÇÃO',
      getBtn: 'RECEBA SEU BÔNUS',
      menuRules: 'REGRA'
    }
  },
  zenbet: {
    en: {
      siteTitle: 'Your bonuses | ZENBET',
      bottomTitle: 'to your deposit',
      footnoteText: '*read more in Terms and Conditions of the Promotion',
      getBtn: 'Get your bonus',
      menuRules: 'rules'
    },
    ru: {
      siteTitle: 'Твои бонусы | БК ZENBET',
      bottomTitle: 'на депозит',
      footnoteText: '*подробнее в Правилах',
      getBtn: 'Забрать бонус',
      menuRules: 'Правила'
    },
    br: {
      siteTitle: 'Welcome Bonus| ZENBET',
      bottomTitle: 'AO SEU DEPÓSITO',
      footnoteText: '* LEIA MAIS EM TERMOS E CONDIÇÕES DA PROMOÇÃO',
      getBtn: 'RECEBA SEU BÔNUS',
      menuRules: 'REGRA'
    }
  }
}
